import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Home from "./Home";
import TestSetup from "./TestSetup";
import Faq from "./Faq";
import Contact from "./Contact";
import MoreInfo from "./MoreInfo";
import TestProcess from "./TestProcess";
import useTestReducer from "../utils/hooks/useTestReducer";
import { Box } from "@mui/system";
import Header from "./Header";
import Footer from "./Footer";
import useSound from "use-sound";
import beep from "../assets/sounds/beeps.mp3";

const PageWithHeader = () => (
  <>
    <Box className="content" sx={styles.contentWrapperBox}>
      <Header />
      <Outlet />
    </Box>
    <Footer />
  </>
);

const PageWithoutHeader = () => (
  <Box className="content" sx={styles.contentWrapperBox}>
    <Outlet />
  </Box>
);

const App = (props: { testing: boolean }) => {
  const [state, dispatch] = useTestReducer();
  const [play] = useSound(beep);

  return (
    <React.StrictMode>
      <Routes>
        <Route path="/" element={<PageWithHeader />}>
          <Route index element={<Home />} />
          <Route path="/testialgus" element={<TestSetup testReducer={{ state, dispatch }} />} />
          <Route path="/kkk" element={<Faq />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/rohkeminfot" element={<MoreInfo />} />
        </Route>
        <Route path="/proovitest" element={<PageWithoutHeader />}>
          <Route index element={<TestProcess state={state} trial={true} testing={props.testing} play={play} />} />
        </Route>
        <Route path="/test" element={<PageWithoutHeader />}>
          <Route index element={<TestProcess state={state} trial={false} testing={props.testing} play={play} />} />
        </Route>
      </Routes>
    </React.StrictMode>
  );
};

export default App;

const styles = {
  contentWrapperBox: {
    margin: "0vh 5vw 5vh 5vw",
  },
};
